import React, { useEffect, useState } from 'react';
import './ProfilePage.css';
import { db, auth } from './firebase';
import { doc, getDoc, collection, getDocs, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { getTotalPosicoes, categoriasPorModo } from "./services/estruturaCategorias";
import nomesBonitosCategoria from "./utils/nomesBonitosCategoria";
import EditarPerfilPopup from "./components/EditarPerfilPopup";
import DefinicoesPopup from "./components/DefinicoesPopup";
import AlertaUrgente from "./components/AlertaUrgente";
import PopupCompartilhar from './components/PopupCompartilhar';
import ExportarApostasInstagram from "./components/ExportarApostasInstagram";
import DOMPurify from "dompurify";
import TimelineEntryPoint from "./components/TimelineEntryPoint";
import "./components/TimelineModal.css";
import "./components/PostarModal.css";
import "./components/ReplyModal.css";

function ProfilePage() {
  const [popupCompartilharAberto, setPopupCompartilharAberto] = useState(false);
  const [config, setConfig] = useState({});
  const [usuario, setUsuario] = useState(null);
  const [usuarioFirestore, setUsuarioFirestore] = useState(null);
  const [previsoesAtivas, setPrevisoesAtivas] = useState({});
  const [modosComApostas, setModosComApostas] = useState([]); // array
  const [popupSelosAberto, setPopupSelosAberto] = useState(false);
  const [seloSelecionado, setSeloSelecionado] = useState(null);
  const [popupEditarAberto, setPopupEditarAberto] = useState(false);
  const [dadosSelos, setDadosSelos] = useState({});
  const [modoSelecionado, setModoSelecionado] = useState("");
  const [todasPrevisoes, setTodasPrevisoes] = useState({});
  const [ranking, setRanking] = useState({});
  const [carregandoPerfil, setCarregandoPerfil] = useState(true);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);
  const [totalPontos, setTotalPontos] = useState(0);

  const [popupDefinicoesAberto, setPopupDefinicoesAberto] = useState(false);
  const [popupAjudaAberto, setPopupAjudaAberto] = useState(false);
  const [popupPontuacaoAberto, setPopupPontuacaoAberto] = useState(false);

  // Conteúdo vindo do Firestore (com cache em sessionStorage)
  const [ajudaConteudo, setAjudaConteudo] = useState({
    comoFuncionaHtml: "",
    tabelaPontuacao: [],
  });
  const [carregandoAjuda, setCarregandoAjuda] = useState(true);

  const navigate = useNavigate();

  const imagemPerfilDefault = "https://firebasestorage.googleapis.com/v0/b/previsoesoscar.firebasestorage.app/o/fotosUsuarios%2Fdefaults%2Fperfil.png?alt=media&token=e1de994b-b337-41ea-992f-fb0929611d36";
  const imagemCabecalhoDefault = "https://firebasestorage.googleapis.com/v0/b/previsoesoscar.firebasestorage.app/o/fotosUsuarios%2Fdefaults%2Fcapa.png?alt=media&token=5a95f438-714b-4eea-a506-bdb619c43c5a";

  // Link público depende do usuário logado
  const linkPerfilPublico = usuario?.uid
    ? `https://www.termometrooscar.com/termometeiro.html#/perfil-publico/${usuario.uid}`
    : "";

  function abrirPopupDefinicoes() { setPopupDefinicoesAberto(true); }
  function fecharPopupDefinicoes() { setPopupDefinicoesAberto(false); }
  function handleSalvarSenha(senhaAtual, novaSenha) { /* reautenticar e atualizar senha */ }
  function handleDeletarConta() { /* deletar conta e dados */ }

  // === AuthState ÚNICA (sem duplicidade)
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        try { sessionStorage.removeItem("usuarioFirestore"); } catch {}
        navigate("/");
        return;
      }

      setUsuario(user);

      // tenta cache
      const cache = sessionStorage.getItem("usuarioFirestore");
      if (cache) {
        try {
          setUsuarioFirestore(JSON.parse(cache));
          // 🔧 NÃO retornar aqui; vamos confirmar com Firestore para evitar "perfil esqueleto"
          return;
        } catch {}
      }

      // busca do Firestore
      try {
        const ref = doc(db, "usuarios", user.uid);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const dados = snap.data();
          setUsuarioFirestore(dados);
          try { sessionStorage.setItem("usuarioFirestore", JSON.stringify(dados)); } catch {}
        } else {
          console.warn("Documento do usuário não encontrado no Firestore.");
          setUsuarioFirestore(null);
        }
      } catch (e) {
        console.error("Erro ao carregar dados do usuário:", e);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // Carregar selos
  useEffect(() => {
    async function carregarSelos() {
      try {
        const snapshot = await getDocs(collection(db, "selos"));
        const resultado = {};
        snapshot.forEach((d) => {
          resultado[d.id] = d.data();
        });
        setDadosSelos(resultado);
      } catch (erro) {
        console.error("Erro ao carregar selos:", erro);
      }
    }
    carregarSelos();
  }, []);

  function SeloPopup({ selos, dadosSelos, onClose, onSelecionar, seloSelecionado }) {
    return (
      <div className="popup-selos-overlay">
        <div className="popup-selos">
          <button className="popup-fechar" onClick={onClose} title="Fechar">×</button>

          <div className="usuario-info2">PINS GANHOS</div>
          <p>
            <strong>ESCOLHA O PIN QUE QUER MOSTRAR:</strong><br />
            <span className="info">Se não escolher, o pin mais recente será exibido.</span>
          </p>

          <div className="lista-selos">
            {selos.map((selo) => {
              const dados = dadosSelos[selo];
              if (!dados) return null;

              return (
                <div
                  key={selo}
                  className={`item-selo ${selo === seloSelecionado ? 'selecionado' : ''}`}
                  onClick={() => onSelecionar(selo)}
                  title={dados.motivo || 'Selo sem descrição'}
                >
                  <img src={dados.imagemUrl} alt={dados.nome} />
                  <p className="motivo-selo">{dados.motivo}</p>
                </div>
              );
            })}
          </div>

          <button className="btn-salvar-selo" onClick={onClose}>SALVAR</button>
        </div>
      </div>
    );
  }

  function abrirPopupSelos() {
    setPopupSelosAberto(true);
    setSeloSelecionado(usuarioFirestore?.selooficial || null);
  }
  function fecharPopupSelos() {
    if (seloSelecionado) atualizarSeloOficial(seloSelecionado);
    setPopupSelosAberto(false);
  }
  async function atualizarSeloOficial(selo) {
    if (!usuario) return;
    try {
      const ref = doc(db, 'usuarios', usuario.uid);
      await updateDoc(ref, { selooficial: selo });
      setUsuarioFirestore((prev) => ({ ...prev, selooficial: selo }));
    } catch (erro) {
      console.error("Erro ao atualizar selo oficial:", erro);
    }
  }

  // Ajuda (com cache)
  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        const cache = sessionStorage.getItem("ajudaTermometeiro");
        if (cache) {
          const parsed = JSON.parse(cache);
          if (ativo) {
            setAjudaConteudo(parsed);
            setCarregandoAjuda(false);
          }
          return;
        }

        const ref = doc(db, "appConteudo", "ajudaTermometeiro");
        const snap = await getDoc(ref);

        if (!ativo) return;

        if (snap.exists()) {
          const data = snap.data() || {};
          const payload = {
            comoFuncionaHtml: data.comoFuncionaHtml || "",
            tabelaPontuacao: Array.isArray(data.tabelaPontuacao) ? data.tabelaPontuacao : [],
          };
          setAjudaConteudo(payload);
          sessionStorage.setItem("ajudaTermometeiro", JSON.stringify(payload));
        } else {
          setAjudaConteudo({ comoFuncionaHtml: "", tabelaPontuacao: [] });
        }
      } catch (e) {
        console.error("Erro ao carregar ajudaTermometeiro:", e);
      } finally {
        if (ativo) setCarregandoAjuda(false);
      }
    })();
    return () => { ativo = false; };
  }, []);

  async function recarregarAjudaDoFirestore() {
    try {
      setCarregandoAjuda(true);
      const ref = doc(db, "appConteudo", "ajudaTermometeiro");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data() || {};
        const payload = {
          comoFuncionaHtml: data.comoFuncionaHtml || "",
          tabelaPontuacao: Array.isArray(data.tabelaPontuacao) ? data.tabelaPontuacao : [],
        };
        setAjudaConteudo(payload);
        sessionStorage.setItem("ajudaTermometeiro", JSON.stringify(payload));
      }
    } catch (e) {
      console.error("Erro ao recarregar ajudaTermometeiro:", e);
    } finally {
      setCarregandoAjuda(false);
    }
  }

  // 🔎 Calcula a data mais recente ENTRE TODAS as categorias de TODOS os modos
  useEffect(() => {
    const dados = todasPrevisoes;
    if (!dados || typeof dados !== "object") {
      setUltimaAtualizacao(null);
      return;
    }

    let maisRecente = null;
    for (const modo of Object.keys(dados)) {
      if (!/^[a-z]+-(indicados|vencedores)$/.test(modo)) continue;
      const blocoModo = dados[modo];
      if (!blocoModo || typeof blocoModo !== "object") continue;

      for (const categoriaId of Object.keys(blocoModo)) {
        const categoria = blocoModo[categoriaId];
        if (!categoria || typeof categoria !== "object") continue;

        const data = categoria.dataAtualizacao;
        if (!data) continue;

        const dataObj =
          data instanceof Date
            ? data
            : data?.seconds
            ? new Date(data.seconds * 1000)
            : typeof data === "string"
            ? new Date(data)
            : null;

        if (dataObj && !isNaN(dataObj)) {
          if (!maisRecente || dataObj > maisRecente) {
            maisRecente = dataObj;
          }
        }
      }
    }

    setUltimaAtualizacao(maisRecente || null);
  }, [todasPrevisoes]);

  function trocarModo(novoModo) { setModoSelecionado(novoModo); }

  useEffect(() => {
    if (modoSelecionado && todasPrevisoes[modoSelecionado]) {
      setPrevisoesAtivas(todasPrevisoes[modoSelecionado]);
    } else {
      setPrevisoesAtivas({});
    }
  }, [modoSelecionado, todasPrevisoes]);

  function gerarNomeModo(modo) {
    const [premiacao, tipo] = modo.split("-");
    const mapaNomes = {
      oscar: "Oscar",
      globodeouro: "Globo de Ouro",
      bafta: "BAFTA",
      sagawards: "The Actor Awards",
      criticschoice: "Critics Choice",
      dga: "DGA",
      pga: "PGA",
    };
    const tipoTexto = tipo === "indicados" ? "Aposta dos Indicados ao" : "Aposta dos Vencedores ao";
    return `${tipoTexto} ${mapaNomes[premiacao] || premiacao}`;
  }

  // Lista das premiações (definida antes de usar no efeito abaixo)
  const premiacoes = [
    { nome: 'Oscar', id: 'oscar' },
    { nome: 'Globo de Ouro', id: 'globodeouro' },
    { nome: 'Critics Choice', id: 'criticschoice' },
    { nome: 'The Actor Awards', id: 'sagawards' },
    { nome: 'BAFTA', id: 'bafta' },
    { nome: 'DGA', id: 'dga' },
    { nome: 'PGA', id: 'pga' },
  ];

  // Configuração (documento único)
  useEffect(() => {
    async function fetchDados() {
      try {
        const ref = doc(db, 'configuracaoVotacao2', 'geral');
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          console.warn("❌ Documento 'geral' não encontrado");
          return;
        }

        const dados = snap.data();

        // Garante que todos os IDs tenham estrutura válida
        const novoConfig = {};
        for (const { id } of premiacoes) {
          novoConfig[id] = dados[id] || {
            statusIndicado: 'fechado',
            statusVencedor: 'fechado',
            abreIndicado: '',
            fechaIndicado: '',
            imagemIndicado: '',
            imagemVencedor: ''
          };
        }

        setConfig(novoConfig);
        console.log("✅ Configuração carregada do documento único");
      } catch (erro) {
        console.error("Erro ao buscar configurações:", erro);
      }
    }

    fetchDados();
  }, []);

  // Carrega snapshot de apostas do usuário (cacheável)
  useEffect(() => {
    if (!usuario?.uid) {
      setCarregandoPerfil(false);
      return;
    }

    async function carregarDadosDoSnap() {
      setCarregandoPerfil(true);
      const chaveCache = `perfil-${usuario.uid}`;

      try {
        // 1️⃣ Tenta cache
        const cacheBruto = sessionStorage.getItem(chaveCache);
        if (cacheBruto) {
          try {
            const cache = JSON.parse(cacheBruto);

            setModosComApostas(cache.modosComApostas);
            setTodasPrevisoes(cache.todasPrevisoes);

            const modoRestaurado = cache.modoSelecionado;
            setModoSelecionado(modoRestaurado);
            setPrevisoesAtivas(cache.todasPrevisoes[modoRestaurado] || {});

            // Ranking com pontos/porcentagem
            const rankingCompleto = {};
            for (const modo of cache.modosComApostas || []) {
              const blocoModo = cache.todasPrevisoes?.[modo] || {};
              rankingCompleto[modo] = {
                ...blocoModo,
                pontos: modo === modoRestaurado ? cache.totalPontos ?? null : null,
                porcentagem: blocoModo.porcentagem ?? null,
              };
            }
            setRanking(rankingCompleto);

            // Total de pontos do topo
            setTotalPontos(rankingCompleto[modoRestaurado]?.pontos ?? 0);

            // Data mais recente global (todas as categorias de todos os modos)
            const dadosCache = cache.todasPrevisoes || {};
            let maisRecente = null;

            for (const modo of Object.keys(dadosCache)) {
              const blocoModo = dadosCache[modo];
              if (!blocoModo || typeof blocoModo !== "object") continue;

              for (const categoriaId of Object.keys(blocoModo)) {
                const categoria = blocoModo[categoriaId];
                if (!categoria || typeof categoria !== "object") continue;

                const data = categoria.dataAtualizacao;
                if (data?.seconds) {
                  const d = new Date(data.seconds * 1000);
                  if (!maisRecente || d > maisRecente) maisRecente = d;
                } else if (typeof data === "string") {
                  const d = new Date(data);
                  if (!maisRecente || d > maisRecente) maisRecente = d;
                }
              }
            }
            if (maisRecente) {
              console.log("🟢 Data mais recente encontrada:", maisRecente);
              setUltimaAtualizacao(maisRecente);
            }

            console.log("🧠 Cache restaurado com sucesso.");
            return; // o finally desliga o loader
          } catch (e) {
            console.warn("⚠️ Erro ao ler cache. Ignorando...");
          }
        }

        // 2️⃣ Leitura única do snapshot de apostas (que já inclui ranking)
        const ref = doc(db, "usuarios", usuario.uid, "snapDropdown2026", "dados");
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          console.warn("❌ SnapDropdown não encontrado (usuário novo sem apostas)");
          // Estado mínimo “vazio” para abrir a página sem travar
          setModosComApostas([]);
          setTodasPrevisoes({});
          setRanking({});
          setModoSelecionado("");
          setPrevisoesAtivas({});
          setTotalPontos(0);
          setUltimaAtualizacao(null);
          return; // o finally desliga o loader
        }

        const dados = snap.data(); // modos, categorias, pontos, porcentagem

        // Data mais recente por modo (campo 'ultimaAtualizacao' em cada modo)
        let maisRecente = null;
        for (const modo of Object.keys(dados)) {
          const blocoModo = dados[modo];

          // Pula se não for objeto (ex: totalPontos)
          if (!blocoModo || typeof blocoModo !== "object") {
            console.warn("⚠️ Ignorado: não é objeto de modo:", blocoModo);
            continue;
          }

          const data = blocoModo.ultimaAtualizacao;
          if (data?.seconds) {
            const d = new Date(data.seconds * 1000);
            if (!maisRecente || d > maisRecente) maisRecente = d;
          } else if (typeof data === "string") {
            const d = new Date(data);
            if (!maisRecente || d > maisRecente) maisRecente = d;
          } else {
            console.warn("⚠️ Modo sem data válida:", data);
          }
        }
        if (maisRecente) {
          console.log("🟢 Data mais recente encontrada:", maisRecente);
          setUltimaAtualizacao(maisRecente);
        }

        if (typeof dados.totalPontos === "number") {
          setTotalPontos(dados.totalPontos);
        }

        const modosComDados = Object.keys(dados).filter((modo) =>
          /^[a-z]+-(indicados|vencedores)$/.test(modo)
        );

        if (modosComDados.length === 0) {
          console.warn("⚠️ Nenhum modo válido encontrado no snapshot.");
          setModosComApostas([]);
          setTodasPrevisoes({});
          setRanking({});
          setModoSelecionado("");
          setPrevisoesAtivas({});
          setTotalPontos(0);
          setUltimaAtualizacao(null);
          return;
        }

        const prioridade = [
          "oscar-vencedores", "oscar-indicados",
          "globodeouro-vencedores", "globodeouro-indicados",
          "bafta-vencedores", "bafta-indicados",
          "sagawards-vencedores", "sagawards-indicados",
          "criticschoice-vencedores", "criticschoice-indicados",
          "dga-vencedores", "dga-indicados",
          "pga-vencedores", "pga-indicados",
        ];
        modosComDados.sort((a, b) => prioridade.indexOf(a) - prioridade.indexOf(b));
        const melhorModo = modosComDados[0];

        setModosComApostas(modosComDados);
        setTodasPrevisoes(dados);
        setModoSelecionado(melhorModo);
        setPrevisoesAtivas(dados[melhorModo] || {});
        setRanking(dados); // define ranking diretamente do snapshot

        sessionStorage.setItem(
          chaveCache,
          JSON.stringify({
            modosComApostas: modosComDados,
            modoSelecionado: melhorModo,
            todasPrevisoes: dados,
            totalPontos: dados.totalPontos ?? null,
          })
        );

        console.log("✅ SnapDropdown carregado e cache salvo");
      } catch (erro) {
        console.error("❌ Erro ao carregar snapDropdown:", erro);
        // Fallback “vazio” para não travar a UI em caso de erro
        setModosComApostas([]);
        setTodasPrevisoes({});
        setRanking({});
        setModoSelecionado("");
        setPrevisoesAtivas({});
        setTotalPontos(0);
        setUltimaAtualizacao(null);
      } finally {
        setCarregandoPerfil(false); // nunca fica preso no loader
      }
    }

    carregarDadosDoSnap();
  }, [usuario?.uid]);

  const formatarData = (data) => {
    if (!data) return 'Em breve';
    const [dataParte, horaParte] = String(data).split('T');
    if (!dataParte) return 'Formato inválido';
    const [ano, mes, dia] = dataParte.split('-');
    if (horaParte) {
      const [hora, minuto] = horaParte.split(':');
      return `${dia}/${mes}/${ano.slice(2)} às ${hora}h${minuto}`;
    } else {
      return `${dia}/${mes}/${ano.slice(2)}`;
    }
  };

  function formatarDataHoraExtenso(valor) {
    if (!valor) return "—";

    let data;
    if (valor instanceof Date) data = valor;
    else if (typeof valor === "string") data = new Date(valor);
    else if (valor?.seconds) data = new Date(valor.seconds * 1000);
    else return "—";

    if (isNaN(data.getTime())) return "—";

    const dia = data.getDate();
    const mes = data.toLocaleDateString("pt-PT", { month: "long" });
    const ano = data.getFullYear();
    const horas = data.getHours().toString().padStart(2, "0");
    const minutos = data.getMinutes().toString().padStart(2, "0");

    return `${dia} de ${mes} de ${ano} às ${horas}h${minutos}`;
  }

  const gerarBotao = (premiacaoId, nome, tipo) => {
    const dados = config[premiacaoId];
    if (!dados) return null;

    const isIndicado = tipo === 'indicados';
    const status = isIndicado ? dados.statusIndicado : dados.statusVencedor;
    const abre = isIndicado ? dados.abreIndicado : dados.abreVencedor;
    const fecha = isIndicado ? dados.fechaIndicado : dados.fechaVencedor;
    const imagens = isIndicado ? dados.imagemIndicado : dados.imagemVencedor;

    const imagemURL = typeof imagens === 'object' ? imagens?.[status] : imagens || '';
    const cor = status === 'aberto' ? 'verde' : 'vermelho';
    const isFechado = status === 'fechado';

    return (
      <button
        className={`voto-card ${cor}`}
        key={`${premiacaoId}-${tipo}`}
        style={{
          pointerEvents: isFechado ? 'none' : 'auto',
          cursor: isFechado ? 'default' : 'pointer',
        }}
        onClick={() => {
          navigate(`/perfil/${premiacaoId}-${tipo}/`);
          window.scrollTo({ top: 0, behavior: 'instant' });
        }}
      >
        <div className="voto-img">
          {imagemURL ? (
            <img src={imagemURL} alt={`${nome} ${tipo}`} />
          ) : (
            `[${nome.toUpperCase()}]`
          )}
        </div>
        <div className={`voto-selo ${status}`}>{status?.toUpperCase() || '---'}</div>
        <p>Apostas dos {isIndicado ? 'Indicados' : 'Vencedores'} do {nome} 2026</p>
        <small className="datascard">
          <strong>Abre dia:</strong> {formatarData(abre)} <br /> <strong>Fecha dia:</strong> {formatarData(fecha)}
        </small>
      </button>
    );
  };

  console.log("🧠 modoSelecionado:", modoSelecionado);
  console.log("📦 previsoesAtivas:", previsoesAtivas);
  console.log("🧭 Data final no render:", ultimaAtualizacao, "→", formatarDataHoraExtenso(ultimaAtualizacao));

  return (
    <div className="profile-container-wrapper">
      <AlertaUrgente />

      {carregandoPerfil && (
        <div className="overlay-carregando">
          <div className="conteudo-carregando">
            <img
              src="https://i.imgur.com/t0gsZRT.png"
              alt="A carregar"
              className="icone-carregando"
            />
            <p className="texto-carregando">Carregando dados do perfil...</p>
          </div>
        </div>
      )}

      <div className={`profile-container ${carregandoPerfil ? 'blurred' : ''}`}>
        {/* TOPO */}
        <div className="header">
          {/* FOTO DE PERFIL SOBREPOSTA */}
          <div className={`foto-usuario ${usuarioFirestore?.especialista ? "especialista" : ""}`}>
            <img
              className="foto-perfil"
              src={usuarioFirestore?.fotoPerfil || imagemPerfilDefault}
              alt="Foto de perfil"
            />
          </div>
          {/* IMAGEM DE FUNDO */}
          <div className="foto-cabecalho">
            <img
              className="imagem-capa"
              src={usuarioFirestore?.fotoCabecalho || imagemCabecalhoDefault}
              alt="Foto de cabeçalho"
            />
          </div>

          {/* BOTÕES SOBREPOSTOS */}
          <div className="header-buttons">
            <button className="btn blue" onClick={() => setPopupCompartilharAberto(true)}>COMPARTILHAR</button>

            {popupCompartilharAberto && (
              <PopupCompartilhar
                link={linkPerfilPublico}
                onClose={() => setPopupCompartilharAberto(false)}
              />
            )}

            <button className="btn yellow" onClick={() => setPopupEditarAberto(true)}>EDITAR PERFIL</button>

            {popupEditarAberto && (
              <div className="popup-overlay">
                <EditarPerfilPopup onClose={() => setPopupEditarAberto(false)} />
              </div>
            )}

            <button className="btn black" onClick={abrirPopupDefinicoes}>
              DEFINIÇÕES
            </button>

            {popupDefinicoesAberto && (
              <DefinicoesPopup
                email={usuario?.email}
                onClose={fecharPopupDefinicoes}
                onSalvarSenha={handleSalvarSenha}
                onDeletarConta={handleDeletarConta}
              />
            )}
          </div>
        </div>

        <div className="usuario-info">
          <h1>
            {usuarioFirestore?.nome && usuarioFirestore?.sobrenome
              ? `${usuarioFirestore.nome} ${usuarioFirestore.sobrenome}`
              : "Usuário"}
          </h1>
          <p className="estado">Estado: <strong>{usuarioFirestore?.estado || "--"}</strong></p>

          {usuarioFirestore?.especialista && (
            <div className="tag-especialista">ESPECIALISTA DO OSCAR</div>
          )}

          {usuarioFirestore?.denominacao && usuarioFirestore?.linkParaSeguir ? (
            <a
              href={usuarioFirestore.linkParaSeguir}
              target="_blank"
              rel="noopener noreferrer"
              className="denominacao link-denominacao"
            >
              {usuarioFirestore.denominacao}
            </a>
          ) : (
            <div className="denominacao">
              {usuarioFirestore?.denominacao || ""}
            </div>
          )}

          <div className="pontuacao-container">
            <div className="pontuacao-label">PONTUAÇÃO</div>
            <div className="pontuacao-numero">{totalPontos}</div>
          </div>

          <p className="pontuacao-info">Atualizações no perfil<br />podem levar até algumas horas.</p>
          <hr className="dotted" />

          <div className="selos-section">
            {usuarioFirestore?.selooficial && dadosSelos[usuarioFirestore.selooficial] && (
              <div className="selo-oficial-bloco">
                <div className="tooltip-wrapper">
                  <img
                    className="selo-oficial-img"
                    src={dadosSelos[usuarioFirestore.selooficial].imagemUrl}
                    alt={dadosSelos[usuarioFirestore.selooficial].nome}
                  />
                  <div className="tooltip-cima">
                    {dadosSelos[usuarioFirestore.selooficial].motivo}
                  </div>
                </div>
              </div>
            )}
            <button className="selos-btn" onClick={abrirPopupSelos}>PINS GANHOS</button>
          </div>

          {popupSelosAberto && (
            <SeloPopup
              selos={usuarioFirestore?.selosGanhos || []}
              dadosSelos={dadosSelos}
              onClose={fecharPopupSelos}
              onSelecionar={setSeloSelecionado}
              seloSelecionado={seloSelecionado}
            />
          )}

          <hr className="dotted" />

          <p className="ultima-atualizacao">
            ÚLTIMA ATUALIZAÇÃO DE APOSTAS<br />
            <strong className="ultima-atualizacao-numero">
              {formatarDataHoraExtenso(ultimaAtualizacao)}
            </strong>
          </p>
        </div>

        <div className="Containerspace">
          {/* BLOCO EXCLUSIVO PARA ESPECIALISTAS */}
          {usuarioFirestore?.especialista && (
            <div className="bloco-especialista">
              {usuarioFirestore?.sobreMim && (
                <p className="texto-sobre"><div className="titulo-sobre-mim">Sobre Mim</div> {usuarioFirestore.sobreMim}</p>
              )}
            </div>
          )}

          {/* CANAL WHATSAPP – CHAMADA */}
          <div className="canal-whatsapp" role="region" aria-label="Canal WhatsApp">
            <div className="cw-inner">
              <div className="cw-icon" aria-hidden="true">
                <img
                  src="https://i.imgur.com/I3FOVfG.png"
                  alt="WhatsApp"
                  className="cw-icon-img"
                  decoding="async"
                />
              </div>

              <div className="cw-text">
                <div className="cw-title">Canal WhatsApp</div>
                <p className="cw-desc">
                  Siga o nosso canal e receba as últimas novidades sobre o <strong>Termometeiro</strong>.
                  Lá avisaremos sobre atualizações, abertura de categorias, apostas e muito mais!
                </p>
              </div>

              <a
                className="cw-btn"
                href="https://whatsapp.com/channel/0029Va6BuQp47XeKT36KmT1y"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Seguir o canal do Termometeiro no WhatsApp (abre em nova aba)"
              >
                Seguir no WhatsApp
              </a>
            </div>
          </div>

          {/* BOTÕES DE AJUDA */}
          <div className="help-bar">
            <button
              className="btn hollow big"
              onClick={async () => { await recarregarAjudaDoFirestore(); setPopupAjudaAberto(true); }}
            >
              COMO FUNCIONA O TERMOMETEIRO?
            </button>

            <button
              className="btn hollow big"
              onClick={async () => { await recarregarAjudaDoFirestore(); setPopupPontuacaoAberto(true); }}
            >
              TABELA DE PONTUAÇÃO
            </button>
          </div>

          {/* POPUP: COMO FUNCIONA */}
          {popupAjudaAberto && (
            <div className="popup-overlay" role="dialog" aria-modal="true">
              <div className="modal-card help-modal">
                <button
                  className="modal-closee"
                  onClick={() => setPopupAjudaAberto(false)}
                  aria-label="Fechar"
                >
                  ×
                </button>

                <h2 className="modal-title">Como funciona o Termometeiro?</h2>

                {carregandoAjuda ? (
                  <p className="modal-loading">Carregando…</p>
                ) : (
                  <div className="modal-body">
                    <div
                      className="rich-html"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(ajudaConteudo.comoFuncionaHtml || "<p>Em breve.</p>", {
                          ALLOWED_TAGS: [
                            "p","br","strong","em","u","span","div",
                            "h1","h2","h3","ul","ol","li","a","blockquote",
                            "table","thead","tbody","tr","th","td"
                          ],
                          ALLOWED_ATTR: ["style","href","target","rel"],
                        }),
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {/* POPUP: PONTUAÇÃO */}
          {popupPontuacaoAberto && (
            <div className="popup-overlay" role="dialog" aria-modal="true">
              <div className="modal-card score-modal">
                <button
                  className="modal-closee"
                  onClick={() => setPopupPontuacaoAberto(false)}
                  aria-label="Fechar"
                >
                  ×
                </button>

                <h2 className="modal-title">Tabela de Pontuação</h2>

                {carregandoAjuda ? (
                  <p className="modal-loading">Carregando…</p>
                ) : ajudaConteudo.tabelaPontuacao?.length ? (
                  <div className="modal-body">
                    <table className="score-table">
                    <thead>
                      <tr>
                        <th>APOSTAS</th>
                        <th>PONTOS ACERTOS</th>
                        <th>PONTOS ERROS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ajudaConteudo.tabelaPontuacao.map((row, idx) => (
                        <tr key={idx}>
                          <td data-label="APOSTAS">{row.aposta || "—"}</td>
                          <td data-label="PONTOS ACERTOS">{row.acerto || "—"}</td>
                          <td data-label="PONTOS ERROS">{row.erro || "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                ) : (
                  <p className="modal-loading">Em breve.</p>
                )}
              </div>
            </div>
          )}

          {/* ÁREA DE VOTAÇÃO */}
          <div className="area-votacao">
            <div className="area-titulo">ÁREA DE APOSTAS</div>
            <div className="votacao-cards">
              {premiacoes.map(({ nome, id }) => (
                <React.Fragment key={id}>
                  {gerarBotao(id, nome, 'indicados')}
                  {gerarBotao(id, nome, 'vencedores')}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* MINHAS PREVISÕES */}
          <div className="previsoes-bloco">
            <div className="previsoes-titulo">MINHAS PREVISÕES 2026</div>
            <ExportarApostasInstagram
              modos={modosComApostas}
              dados={todasPrevisoes}
              ranking={ranking}
              nomesBonitos={nomesBonitosCategoria}
              defaultModo={modoSelecionado}
              usuario={{
                nome: usuarioFirestore?.nome,
                sobrenome: usuarioFirestore?.sobrenome,
                fotoPerfil: usuarioFirestore?.fotoPerfil
              }}
              // categoriasPorModo={categoriasPorModo}
            />
            <div className="previsoes-dropdown">
              <select
                value={modoSelecionado}
                onChange={(e) => trocarModo(e.target.value)}
                className="dropdown-modos"
              >
                {modosComApostas
                  .filter((modo) => /^[a-z]+-(indicados|vencedores)$/.test(modo))
                  .map((modo) => (
                    <option key={modo} value={modo}>
                      {gerarNomeModo(modo)}
                    </option>
                  ))}
              </select>
            </div>

            {ranking?.[modoSelecionado]?.porcentagem && (
              <div className="barra-porcentagem">
                Porcentagem de acertos: {ranking[modoSelecionado].porcentagem}%
                {ranking[modoSelecionado]?.pontosmodo !== undefined && (
                  <div className="pontosmodobarra">
                    Total de Pontos: {ranking[modoSelecionado].pontosmodo}
                  </div>
                )}
              </div>
            )}

            <div className="blocos-previsoes">
              {(() => {
                // Se categoriasPorModo[premiacao] não existir, usa as categorias com apostas
                const todasCategorias = Object.keys(previsoesAtivas || {});
                const categoriasDefinidas = categoriasPorModo[modoSelecionado] || todasCategorias;
                const listaOrdenada = categoriasDefinidas.filter(cat => todasCategorias.includes(cat));

                console.log("🧩 Entrou no render dos blocos");
                console.log("🎯 Categorias encontradas:", Object.keys(previsoesAtivas || {}));

                return listaOrdenada.map((categoriaId) => {
                  const categoria = previsoesAtivas?.[categoriaId];
                  const posicoes = Object.entries(categoria || {})
                    .filter(([key]) => key !== "dataAtualizacao" && !isNaN(Number(key)))
                    .map(([_, val]) => val)
                    .filter((item) => item?.titulo)
                    .sort((a, b) => a.ordem - b.ordem);
                  const dataMaisRecente = categoria?.dataAtualizacao || null;

                  return (
                    <div className="bloco-previsao" key={categoriaId}>
                      <div className="cabecalho-previsao amarelo">
                        {nomesBonitosCategoria[categoriaId] || categoriaId}
                        {ranking?.[modoSelecionado]?.[categoriaId]?.pontos !== undefined && (
                          <span className="pontos-categoria"> {ranking[modoSelecionado][categoriaId].pontos} pontos</span>
                        )}
                      </div>

                      <div className="lista-posicoes">
                        {posicoes
                          .filter((pos) => pos?.titulo)
                          .sort((a, b) => a.ordem - b.ordem)
                          .map((pos, i) => {
                            const isAcertouTrue  = pos.acertou === true || pos.acertou === "true";
                            const isAcertouFalse = pos.acertou === false || pos.acertou === "false";

                            return (
                              <div
                                className={`item-posicao ${isAcertouFalse ? "opaco" : ""}`}
                                key={i}
                                aria-disabled={isAcertouFalse ? "true" : "false"}
                              >
                                <div className={`posicao-circulo cor-${i + 1}`}>{i + 1}º</div>
                                <div className="ligacao-horizontal" />
                                <div className="wrapper-circular">
                                  <img
                                    className="poster-candidato"
                                    src={pos.imagem || "https://i.imgur.com/6MbQoCt.png"}
                                    alt={pos.titulo}
                                  />
                                </div>
                                <div className="info-candidato">
                                  <strong>{pos.titulo}</strong>
                                  <div className="subinfo">
                                    {pos.filme || pos.pais || ""}
                                    {isAcertouTrue && <span className="selo-acertou">ACERTEI</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>

                      <div className="data-atualizacao">
                        Última Atualização: <strong>{dataMaisRecente ? formatarDataHoraExtenso(dataMaisRecente) : "—"}</strong>
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          </div>

          <div className="arquivo">Arquivo</div>

          {/* === Timeline do Termometeiro (botão flutuante + modais) === */}
          {auth.currentUser && usuarioFirestore && (
            <TimelineEntryPoint
              usuarioDoc={{ ...usuarioFirestore, uid: auth.currentUser.uid }}
              snapByModo={todasPrevisoes || {}}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
